import type { DealFormDataWithTargeting, DealOaApi } from '@openx/types/deal.ts';
import type { Package, PackageFormState, PackageListItem } from '@openx/types/package.ts';
import { noop } from '@openx/utils/noop.ts';
import { createContext, type ReactNode } from 'react';
import type { DeepPartialSkipArrayKey } from 'react-hook-form';
import type { DealOption } from '../components/DealSelect/utils/types.ts';
import type { OpenXAgentTool } from '../components/Home/utils/types.ts';

export type OpenXAgentSidePanel<T = unknown> = {
  component: ReactNode;
  state?: T;
};

export type OpenXAgentToolData =
  | DealOaApi
  | DealOption
  | DeepPartialSkipArrayKey<DealFormDataWithTargeting>
  | Package
  | PackageListItem
  | PackageFormState;

export type OpenXAgentToolType = {
  toolId: OpenXAgentTool | null;
  toolData: OpenXAgentToolData | null;
};

export type OpenXAgentContextType = {
  isOpenXAgentOpen: boolean;
  setIsOpenXAgentOpen: (isOpen: boolean) => void;
  sidePanel: OpenXAgentSidePanel | null;
  openSidePanel: <T>(content: OpenXAgentSidePanel<T>) => void;
  closeSidePanel: () => void;
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
  activeTool: OpenXAgentToolType;
  setActiveTool: (arg0: OpenXAgentToolType) => void;
  setActiveToolId: (toolId: OpenXAgentTool | null) => void;
};

export const initState: OpenXAgentContextType = {
  isOpenXAgentOpen: false,
  setIsOpenXAgentOpen: noop,
  sidePanel: null,
  openSidePanel: noop,
  closeSidePanel: noop,
  isMenuOpen: false,
  setIsMenuOpen: noop,
  activeTool: {
    toolId: null,
    toolData: null,
  },
  setActiveTool: noop,
  setActiveToolId: noop,
};

export const OpenXAgentContext = createContext<OpenXAgentContextType>(initState);
